import React from 'react';

import UiValidate from '../../../components/forms/validation/UiValidate';
// import MaskedInput from '../../../components/forms/inputs/MaskedInput'
// import UiDatepicker from '../../../components/forms/inputs/UiDatepicker';

const validationOptions = {
  rules: {
    email: {
      required: true,
      email: true,
    },
    password: {
      required: true,
      minlength: 6,
      maxlength: 128,
      telemetryPassword: true,
    },
    passwordConfirm: {
      required: true,
      minlength: 6,
      maxlength: 128,
      equalTo: '#password',
      telemetryPassword: true,
    },
    firstname: {
      required: true,
    },
    lastname: {
      required: true,
    },
    gender: {
      required: true,
    },
    terms: {
      required: true,
    },
    clientcode: {
      required: false,
    },
    personal: {
      required: true,
    },
  },

  // Messages for form validation
  messages: {
    login: {
      required: 'Please enter your login',
    },
    email: {
      required: 'Please enter your email address',
      email: 'Please enter a VALID email address',
    },
    password: {
      required: 'Please enter your password',
    },
    passwordConfirm: {
      required: 'Please enter your password one more time',
      equalTo: 'Please enter the same password as above',
    },
    firstname: {
      required: 'Please select your first name',
    },
    lastname: {
      required: 'Please select your last name',
    },
    gender: {
      required: 'Please select your gender',
    },
    terms: {
      required: 'You must agree with Terms and Conditions. ',
    },
    personal: {
      required: 'You must confirm that you have reviewed your personal information before proceeding. ',
    },
  },
};

export default class RegistrationForm extends React.Component {
  onSubmit(e) {
    e.preventDefault();

    const $form = $(this.refs.registerForm);
    const $email = $(this.refs.email);
    const $password = $(this.refs.password);
    const $firstName = $(this.refs.firstname);
    const $lastName = $(this.refs.lastname);
    const $clientCode = $(this.refs.clientcode);
    const $personal = $(this.refs.personal);

    if ($form.data('validator')) {
      if ($form.valid()) {
        this.props.onSubmit({
          email: $email.val(),
          password: $password.val(),
          firstName: $firstName.val(),
          lastName: $lastName.val(),
          clientCode: $clientCode.val(),
          isReviewedPersonalInformation: $personal.is(":checked")
        })
      }
    }
  }

  render() {
    const { error, message, isLoading } = this.props;
    return (
      <UiValidate options={validationOptions}>
        <form
          ref="registerForm"
          id="form-register"
          className="smart-form register-form"
          noValidate="novalidate"
          onSubmit={this.onSubmit.bind(this)}
        >
          <header>Registration form</header>
          {error && <div className="alert adjusted alert-danger fade in">{error}</div>}
          {message && <div className="alert adjusted alert-info fade in">{message}</div>}
          <fieldset>
            <section>
              <label className="input">
                {' '}
                <i className="icon-append fa fa-envelope-o" />
                <input
                  type="email"
                  name="email"
                  ref="email"
                  placeholder="Email address"
                  autoComplete="username"
                />
                <b className="tooltip tooltip-bottom-right">
                  Needed to verify your account
                </b>{' '}
              </label>
            </section>

            <section>
              <label className="input">
                {' '}
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  name="password"
                  ref="password"
                  placeholder="Password"
                  id="password"
                  autoComplete="new-password"
                />
                <b className="tooltip tooltip-bottom-right">
                  Don't forget your password
                </b>{' '}
              </label>
            </section>

            <section>
              <label className="input">
                {' '}
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  name="passwordConfirm"
                  placeholder="Confirm password"
                  autoComplete="new-password"
                />
                <b className="tooltip tooltip-bottom-right">
                  Don't forget your password
                </b>{' '}
              </label>
            </section>
          </fieldset>

          <fieldset>
            <div className="row">
              <section className="col col-6">
                <label className="input">
                  <input
                    type="text"
                    name="firstname"
                    ref="firstname"
                    placeholder="First name"
                  />
                </label>
              </section>
              <section className="col col-6">
                <label className="input">
                  <input
                    type="text"
                    name="lastname"
                    ref="lastname"
                    placeholder="Last name"
                  />
                </label>
              </section>
            </div>

            <div className="row">
              <section className="col col-6">
                <label className="input">
                  <input
                    type="text"
                    name="clientcode"
                    ref="clientcode"
                    placeholder="Code"
                  />
                </label>
              </section>
              <section className="col col-6">
               
              </section>
            </div>

            {/* <div className="row">
              <section className="col col-6">
                <label className="select">
                  <select name="gender" defaultValue={"0"}>
                    <option value="0" disabled={true}>Gender</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                    <option value="3">Prefer not to answer</option>
                  </select> <i/> </label>
              </section>
              <section className="col col-6">
                <label className="input"> <i className="icon-append fa fa-calendar"/>
                  <UiDatepicker type="text" name="request" placeholder="Request activation on"
                                dateFormat="dd/mm/yy"/>
                </label>
              </section>
            </div> */}

            <section>
              {/* <label className="checkbox">
                <input type="checkbox" name="subscription" id="subscription"/>
                <i/>I want to receive news and special offers</label> */}
              <label className="checkbox">
                <input type="checkbox" name="terms" id="terms" ref="terms" />
                <i />I have read and agree to the{' '}
                <a data-toggle="modal" data-target="#myModal">
                  Terms and Conditions 
                </a>
                {' '}and{' '}
                <a data-toggle="modal" data-target="#modalPrivacyPolicy">
                  Privacy Policy
                </a>
              </label>
              <label className="checkbox">
                <input type="checkbox" name="personal" id="personal" ref="personal" />
                <i />I have reviewed my personal information and confirm this information is correct
              </label>
            </section>
          </fieldset>
          <footer>
            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              Submit
            </button>
          </footer>
          {isLoading &&
            <div className="cover">
              <div className="spinner inline"></div>
            </div>
          }
        </form>
      </UiValidate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/components/RegistrationForm.js